module.exports = "<img #thumbnail class=\"thumbnail\" [src]=\"image\" (click)=\"showLightbox()\"/>\n<div class=\"modal\" *ngIf=\"shown\" (click)=\"hideLightbox()\">\n    <div class=\"lightbox\">\n        <a class=\"close\" (click)=\"hideLightbox()\">&times;</a>\n        <div class=\"title\">{{title}}</div>\n        <img [src]=\"image\"/>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/lightbox-thumbnail/lightbox-thumbnail.component.html
// module id = ./src/app/lightbox-thumbnail/lightbox-thumbnail.component.html
// module chunks = main